import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export type AccordionItem = {
  q: string;
  a: string;
};
export function Accordion({
  items
}: {
  items: AccordionItem[];
}) {
  const [open, setOpen] = useState<number | null>(0);
  return <div className="divide-y divide-oat/60 border-y border-oat/60" data-id="element-43" data-mp="28et682ejtzml">
      {items.map((item, i) => {
      const isOpen = open === i;
      return <div key={item.q} data-id="element-44" data-mp="2n5saj18cq20d" data-mpi={i}>
            <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left" data-id="element-45" data-mp="2i5dzdabgeby4">
              <span className="type-ui text-base text-coffee md:text-lg" data-id="element-46" data-mp="2s43jzauqiai2">
                {item.q}
              </span>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-oat text-coffee" data-id="element-47" data-mp="11r4kd6t3pzjy">
                {isOpen ? <MinusIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-48" data-mp="3g4m1wclto9ef" /> : <PlusIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-49" data-mp="3l2xa6iwgybuj" />}
              </span>
            </button>
            <AnimatePresence initial={false} data-id="element-50" data-mp="3q18ksvul8qdt">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-51" data-mp="3uti8e588decx">
                  <p className="type-body max-w-2xl pb-7 text-sm text-ink/65" data-id="element-52" data-mp="coopdx06upcx">
                    {item.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}